import { useAppSelector } from 'store';

/**
 * Custom hook to check if user has a role
 * @returns {object} Object with roles and hasRole function
 */
export const useUserRoles = () => {
  const roles = useAppSelector((state) => state.user.roles);
  return {
    roles,
    hasRole: (role: string | string[]) =>
      Array.isArray(role) ? role.some((r) => roles?.includes(r)) : roles?.includes(role),
  };
};
